import { render, staticRenderFns } from "./MeusDadosPerfil.vue?vue&type=template&id=563b4315&scoped=true"
import script from "./MeusDadosPerfil.vue?vue&type=script&lang=js"
export * from "./MeusDadosPerfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563b4315",
  null
  
)

export default component.exports